import styles from './DescriptionView.module.scss';
export interface DescriptionViewProps {
    text?: string;
    title?: string;
    title2?: string;
    createdAt?: string;
    updatedAt?: string;
    minigridTitle?: string;
    text2?: string;

}
export default function DescriptionView({text, title = 'Description', title2,text2, createdAt, updatedAt, minigridTitle}: DescriptionViewProps)  {
  return (
    <div className={styles['container']}>
    <h2 className={styles['container__title']}>{title}</h2>
    <p className={styles['container__text-content']}>{text}</p>
    <h2 className={styles['container__title']}>{title2}</h2>
    <p className={styles['container__text-content']}>{text2}</p>
    {createdAt && (
        <p className={styles["container__date"]}>
          Crée le {createdAt}{" "}
          {createdAt !== updatedAt && <>et mise à jour le {updatedAt}</>}
          
    
        </p>
      )}
    </div>
  )
}
